import {css} from '@emotion/css';
import {Breakpoints, mq} from '../../../styles/js/mixins';
import {colours, spacing} from '../../../styles/js/variables';
import {ContainerSizes} from '../../../styles/js/variables/elementSizing';

const styles = {
  businessServices: css`
    label: businessServices;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${spacing.M} ${spacing.XS};
    background-color: ${colours.background.MAIN};

    ${mq(Breakpoints.TABLET)} {
      padding: ${spacing.XXXL} ${spacing.XS};
    }
  `,
  container: css`
    label: businessServices__container;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    max-width: ${ContainerSizes.MD};
    margin-bottom: ${spacing.XS};

    ${mq(Breakpoints.TABLET)} {
      align-items: center;
    }
  `,
  subtitle: css`
    label: businessServices__subtitle;
    p {
      text-align: center;
    }
  `,
  title: css`
    label: businessServices__title;
    ${mq(Breakpoints.TABLET)} {
      text-align: center;
    }
  `,
  cardLink: css`
    label: businessServices__cardLink;

    .cardLink__icon {
      display: flex;
      align-items: center;
      align-self: center;
      margin-bottom: 0;

      ${mq(Breakpoints.TABLET)} {
        margin-bottom: ${spacing.XXS};
      }
    }

    ${mq(Breakpoints.TABLET)} {
      width: 100%;
      max-width: 32rem;
    }
  `,
};

export default styles;
